<template>
  <li class="reviewParts">
    <div class="contentsWrap reviewCard reviews_wrap">
      <div class="location">
        <ol>
          <li>{{ review.area.island_name }}</li>
          <li>{{ review.area.area_name }}</li>
        </ol>
      </div>
      <a :href="'/shop/' + review.large_category_id + '/' + review.shop_id + '/review'" class="name">{{ shopName }}</a>
      <hr />
      <div class="iconWithName">
        <div class="icon">
          <img :src="src(review.user.image_url)">
        </div>
        <div class="name">{{ review.user.name }}</div>
      </div>
      <post-edit type="review" :review="review" :shop-name="shopName" :image-path="imagePath"></post-edit>
      <!-- <review-stars :stars="review.review" wrap-class="reviewStars"></review-stars> -->
      <h3 class="title">{{ review.title }}</h3>
      <slide-photos :photos='review.photos' :image-path="imagePath" customClass="reviewPhoto"></slide-photos>
      <p class="content" v-if="!open">
        {{ content }}
        <span class="more" v-if="review.content.length > contentLength" @click.prevent="open = !open">…もっと見る</span>
      </p>
      <p class="content" v-if="open">
        {{ review.content }}
        <span class="more" v-if="review.content.length > contentLength" @click.prevent="open = !open">閉じる</span>
      </p>
      <div class="date">{{ review.created_at }}</div>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    review: Object,
    shopName: String,
    imagePath: String
  },
  data: () =>({
    contentLength: 50,
    open: false
  }),
  computed: {
    content() {
      return this.review.content.substr(0, this.contentLength)
    }
  },
  methods: {
    src(url) {
      if (this.$_.isEmpty(url)) {
        return '/img/aloco_img_2.svg'
      } else {
        return this.imagePath + url
      }
    }
  }
}
</script>

<style lang="scss">
.mypage.reviews {
  .reviewParts {
    .reviews_wrap {
      border: none;
      padding: 0;
    }
  }
  .contentsWrap {
    border-radius: 10px;

    .iconWithName {
      padding-top: 16px;
    }
    .content {
      white-space: pre-line;
      height: auto;
      overflow: unset;
      max-height: none;
    }
    .reviewStars {
      margin-top: 1rem;
    }
  }
}
</style>
